import { Pipe, PipeTransform } from "@angular/core";
import {Task} from '../entities/Task';
import {isArrayLike} from 'rxjs/util/isArrayLike';

@Pipe({
  name: "SortPipe"
})
export class SortPipe  implements PipeTransform {
  transform(array: any[], field: string, sortReverse: boolean): any[] {


    if(sortReverse) {
      array.sort((a: any, b: any) => {
        if (a[field] < b[field]) {
          return -1;
        } else if (a[field] > b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    else{
      array.sort((a: any, b: any) => {
        if (a[field] > b[field]) {
          return -1;
        } else if (a[field] < b[field]) {
          return 1;
        } else {
          return 0;
        }
      });
    }
    return array;
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/pipes/SortPipe.ts